/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DomainsControllerFindAllQueryResponse, DomainsControllerFindAllQueryParams, DomainsControllerFindAll401, DomainsControllerFindAll403 } from "../../models/domainsController/DomainsControllerFindAll";

function getDomainsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/domains` as const }  
  return res
}

/**
 * @summary List domains for an organization
 * {@link /api/v1/domains}
 */
export async function domainsControllerFindAll(params: DomainsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DomainsControllerFindAllQueryResponse, ResponseErrorConfig<DomainsControllerFindAll401 | DomainsControllerFindAll403>, unknown>({ method : "GET", url : getDomainsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}